"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.spacing = exports.radius = exports.fontSizes = exports.fontFamily = void 0;
/**
 * Layout and typography scales. Values match the historical
 * `PitBrain.Mobile/constants/NavigationThemes.ts` so neither app shifts.
 */

/** Spacing scale (px / dp). */
const spacing = exports.spacing = {
  xs: 4,
  sm: 10,
  md: 15,
  lg: 20,
  xl: 30
};

/** Border radius scale (px / dp). */
const radius = exports.radius = {
  small: 8,
  medium: 10,
  large: 16
};

/** Font sizes (px / sp). */
const fontSizes = exports.fontSizes = {
  small: 12,
  body: 14,
  subtitle: 18,
  title: 24,
  heading: 28,
  display: 42
};

/**
 * Typography family (web). Owner decision (Epic #289): Inter with system
 * fallbacks. Mobile currently uses the platform default and ignores this.
 */
const fontFamily = exports.fontFamily = "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif";